/* global saveOrganisationUrl, subscriptionPlans, editablePlansIds */

import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import SaveOrganisationForm from './SaveOrganisationForm';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function CreateOrganisationModal(props) {
    const [createOrganisationModalElement, setCreateOrganisationModalElement] = useState(null);

    const createOrganisationModalRef = useRef();

    useEffect(() => {
        createOrganisationModalRef && setCreateOrganisationModalElement(new Modal(createOrganisationModalRef.current, modalOptions(false)));
    }, []);

    const closeModal = () => {
        createOrganisationModalElement && createOrganisationModalElement.hide();
    };
    const openModal = () => {
        createOrganisationModalElement && createOrganisationModalElement.show();
    };

    const postSaveHandler = () => {
        window.location.reload();
    };

    return (
        <>
            <Button variant="primary" onClick={openModal}>
                {$t('Create new organisation')}
            </Button>

            <div id="create-organisation" ref={createOrganisationModalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Create New Organisation')} close={closeModal}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                <SaveOrganisationForm
                                    saveOrganisationUrl={props.saveOrganisationUrl}
                                    postSaveHandler={postSaveHandler}
                                    cancelHandler={closeModal}
                                    action={'create'}
                                    canEdit={true}
                                    canEditDetails={true}
                                    forModal={true}
                                    subscriptionPlans={subscriptionPlans || []}
                                    canChangePlan={true}
                                    editablePlansIds={props.editablePlansIds}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

if (document.getElementById('createOrganisationModal')) {
    ReactDOM.render(
        <App>
            <CreateOrganisationModal
                saveOrganisationUrl={saveOrganisationUrl}
                subscriptionPlans={subscriptionPlans || []}
                editablePlansIds={editablePlansIds}
            />
        </App>,
        document.getElementById('createOrganisationModal'),
    );
}
